export default "__VITE_ASSET__BVPQyB$Y__"